'use client';

import React, { useEffect, useState } from 'react';
import ReactTextTransition, { presets } from 'react-text-transition';

const TextTransition: React.FC<{
  texts: string[];
}> = (props) => {
  const { texts } = props;

  const [mounted, setMounted] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) { return; }

    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000,
    );

    return () => clearTimeout(intervalId);
  }, [mounted]);

  if (!mounted) {
    return <>{texts[0]}</>;
  }

  return (
    <ReactTextTransition inline springConfig={presets.gentle}>
      {texts[index % texts.length]}
    </ReactTextTransition>
  );
};

export default TextTransition;
